import * as React from 'react';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { useLocalization } from '~/framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/pro-regular-svg-icons';

export const UndoButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().undo().run()}
         isDisabled={!editor.can().undo()}
         icon={<FontAwesomeIcon icon={faUndo} />}
         title={_js('Undo')}
         shortcut={'z'}
      ></TiptapButton>
   );
};
